import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=6b247111"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=6b247111&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports